import { checkValidity } from "../../../common/utils/inputValidityChecker";
import { ValidationFormDataPlanBT } from "../components/PlanBT/CreateUpdatePlanBTForm/CreateUpdatePlanBTFormView/CreateUpdatePlanBTFormView";
import { PlanBTPatch } from "../types/planBT.types";

export const isErrorPlanBTCheck = (PlanBT : PlanBTPatch, PlanImage: null | undefined | File) : ValidationFormDataPlanBT  | null => {
    let isAllValid = true

    let errorFound : ValidationFormDataPlanBT = {
        isErrorName: false,
        isErrorDescription: false,
        isErrorImagePlan: false,
        isErrorMinigrid: false
    }
    
    if (!checkValidity(PlanBT.plan_name || '', 'text-not-empty')) {
        errorFound.isErrorName = true
        isAllValid = false

    }

    if (!checkValidity(PlanBT.plan_description, 'text-not-empty')) {
        errorFound.isErrorDescription = true
        isAllValid = false
    }

    if (!PlanBT.plan_minigrid) {
        errorFound.isErrorMinigrid = true
        isAllValid = false
    }

    if (isAllValid) {
        return null
    }

    return errorFound
 
}